import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Programs from "./pages/Programs";
import Donate from "./pages/Donate";
import GetInvolved from "./pages/GetInvolved";
import Events from "./pages/Events";
import Impact from "./pages/Impact";
import Sponsors from "./pages/Sponsors";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import TransparencyPolicy from "./pages/TransparencyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import WhereYourDonationsGo from "./pages/WhereYourDonationsGo";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

// Layout wrapper - hide nav/footer on admin page
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <Navigation />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/donate/success" element={<Donate />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/events" element={<Events />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/transparency-policy" element={<TransparencyPolicy />} />
            <Route path="/refund-policy" element={<RefundPolicy />} />
            <Route path="/where-donations-go" element={<WhereYourDonationsGo />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
